import { CaseFormSection } from '@/components/dashboard/CaseDetails'
import Flex from '@/components/priority/Flex/Flex'
import { SidebarMenuSaveSection } from '../SidebarMenuSaveSection'
import { useIsM3Order } from '@/hooks/utility/useIsM3Order'

type CasePreferencesMenuProps = {
  saveCase: () => Promise<void> | void
}

const CasePreferencesMenu = ({ saveCase }: CasePreferencesMenuProps) => {
  const isM3Order = useIsM3Order()
  return (
    <>
      <Flex full center padding="8px 8px 100px 8px" gap="8px" column>
        <CaseFormSection
          formSection="headers"
          sidebar={true}
          saveAndContinue={saveCase}
          isM3Order={isM3Order}
        />
      </Flex>
      <SidebarMenuSaveSection saveCase={saveCase} />
    </>
  )
}

export default CasePreferencesMenu
